import React from 'react';
import { Route, Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import AuthLayout from '../layout/AuthLayout/AuthLayout';

const AuthRoute = () => {
  const { user } = useAuth();

  return (
    !user ? (
      <AuthLayout>
        <Outlet />
      </AuthLayout>
    ) : (
      <Navigate to="/" replace />
    )
  );
};

export default AuthRoute;
